import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Field, reduxForm, SubmissionError } from 'redux-form'
import { Translate, I18n } from 'react-redux-i18n'
import Grid from 'material-ui/Grid'
import MenuItem from 'material-ui/Menu/MenuItem'
import _ from 'lodash'
import {
  StripeProvider,
  Elements,
  injectStripe,
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement
} from 'react-stripe-elements'

import withStripe from '../../hocs/stripe'
import withBilderlingspay from '../../hocs/bilderlingspay'
import TabContent from '../dashboard/tab_content'
import { ProfileEditWalletsReduxForm } from '../profile/edit'
import { submit as submitStripePayment } from 'modules/payments/stripe'
import Loading from 'components/loading'
import ValidationErrors from '../users/validation_errors'
import Group from '../users/group'
import Submit from '../users/submit'
import jsonSelector from 'selectors/json'
import parametersSelector from 'selectors/parameters'
import powered_by_stripe from 'assets/images/Stripe Badges/Outline Dark/powered_by_stripe.svg'

const Deposits = ({ config_parameters, abilities }) =>
  abilities.can_user_make_deposits ? (
    <div>
      <h2>{I18n.t('deposits.h')}</h2>
      <br />
      <br />
      <div className="receiving-address">
        <h3>{I18n.t('deposits.enter_eth_address')}</h3>
        <ProfileEditWalletsReduxForm />
      </div>
      <h3>{I18n.t('deposits.make_a_deposit')}</h3>
      <br />
      <TabContent />

      <div>
        <br />
        <br />
        <h2>{I18n.t('deposits.credit_card_header')}</h2>
        <br />
        <div className="alert alert-dismissible alert-warning">
          {I18n.t('deposits.credit_card_notice')}
        </div>
        <BilderlingspayReduxForm />
      </div>

      {false &&
        config_parameters['stripe_public_key'] && (
          <div>
            <br />
            <div className="or-box">
              <span>{I18n.t('deposits.or')}</span>
            </div>

            <h3>{I18n.t('deposit_by_credit_card')}</h3>
            <StripeProvider apiKey={config_parameters['stripe_public_key']}>
              <Elements>
                <StripeReduxForm />
              </Elements>
            </StripeProvider>
          </div>
        )}
    </div>
  ) : (
    <h2>You are not allowed to deposit</h2>
  )

const BilderlingspayForm = ({ handleSubmit, submitting, loading, error }) => (
  <form onSubmit={handleSubmit}>
    <Loading active={loading} />
    <br />
    {error && <ValidationErrors errors={JSON.parse(error)} />}
    <Grid container direction="column">
      <Grid item>
        <Grid container>
          <Grid item md={6} xs={12}>
            <Field
              name="amount"
              type="text"
              component={Group}
              label={I18n.t('deposits.stripe.amount')}
              required
              autoComplete="off"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Field
              select
              name="currency"
              component={Group}
              label={I18n.t('deposits.stripe.currency')}
              required
            >
              {_.map(['USD'], code => (
                <MenuItem key={code} value={code}>
                  {code}
                </MenuItem>
              ))}
            </Field>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container>
          <Grid item md={4} xs={12} />
          <Grid item md={4} xs={12}>
            <br />
            <Submit value={I18n.t('deposits.submit')} disabled={submitting} />
          </Grid>
          <Grid item md={4} xs={12} />
          <Grid item md={4} xs={12} />
          <Grid item md={4} xs={12}>
            <div className="text-center">
              <img
                src={require('../../../assets/images/card-logo2x.png')}
                alt=""
                width={132}
                height={35}
              />
            </div>
          </Grid>
          <Grid item md={4} xs={12} />
        </Grid>
      </Grid>
    </Grid>
  </form>
)

const StripeForm = ({ handleSubmit, submitting, loading, error }) => (
  <form onSubmit={handleSubmit}>
    <Loading active={loading} />
    <br />
    {error && <ValidationErrors errors={JSON.parse(error)} />}
    <Grid container direction="column">
      <Grid item>
        <Grid container>
          <Grid item md={6} xs={12}>
            <div className="form-group-mui custom">
              <label>{I18n.t('deposits.stripe.card_number')}</label>
              <CardNumberElement />
            </div>
          </Grid>
          <Grid item md={6} xs={12}>
            <Field
              name="amount"
              type="text"
              component={Group}
              label={I18n.t('deposits.stripe.amount')}
              required
              autoComplete="off"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Grid container>
              <Grid item md={6} xs={12}>
                <div className="form-group-mui custom">
                  <label>{I18n.t('deposits.stripe.card_expiry')}</label>
                  <CardExpiryElement />
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <div className="form-group-mui custom">
                  <label>{I18n.t('deposits.stripe.card_cvc')}</label>
                  <CardCVCElement />
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={6} xs={12}>
            <Field
              select
              name="currency"
              component={Group}
              label={I18n.t('deposits.stripe.currency')}
              required
            >
              {_.map(['USD'], code => (
                <MenuItem key={code} value={code}>
                  {code}
                </MenuItem>
              ))}
            </Field>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container>
          <Grid item md={4} xs={12} />
          <Grid item md={4} xs={12}>
            <br />
            <Submit value={I18n.t('deposits.submit')} disabled={submitting} />
          </Grid>
          <Grid item md={4} xs={12} />
        </Grid>
      </Grid>
      <Grid item>
        <div className="text-center">
          <img src={powered_by_stripe} alt="" />
        </div>
      </Grid>
    </Grid>
  </form>
)

const mapStateToProps = state => ({
  loading: state.payments.stripe.index.loading,
  config_parameters: parametersSelector(state),
  abilities: jsonSelector('infos.abilities')(state),
  initialValues: {
    currency: 'USD'
  }
})

const mapDispatchToProps = dispatch => bindActionCreators({ submitStripePayment }, dispatch)

const validate = values => {
  const errors = {}
  if (values.amount && !/^\d+(\.\d{1,2})?$/.test(values.amount)) {
    errors.amount = <Translate value="deposits.stripe.amount_validation_error" />
  }
  return errors
}

export const BilderlingspayReduxForm = withBilderlingspay(
  reduxForm({
    form: 'bilderlingspay',
    onSubmit: (props, dispatch, { createBilderlingspayPayment }) =>
      createBilderlingspayPayment(props).catch(details => {
        throw new SubmissionError({ ...details, _error: JSON.stringify(details) })
      }),
    onSubmitSuccess: (props, dispatch, { reset }) => reset(),
    validate
  })(BilderlingspayForm)
)

export const StripeReduxForm = injectStripe(
  connect(mapStateToProps, mapDispatchToProps)(
    reduxForm({
      form: 'stripe',
      onSubmit: (props, dispatch, { stripe, submitStripePayment }) =>
        submitStripePayment({ stripe, ...props }).catch(details => {
          throw new SubmissionError({ ...details, _error: JSON.stringify(details) })
        }),
      onSubmitSuccess: (props, dispatch, { reset }) => reset(),
      validate
    })(StripeForm)
  )
)

export default withStripe(connect(mapStateToProps, mapDispatchToProps)(Deposits))



// WEBPACK FOOTER //
// ./src/containers/pages/deposits/index.js